import Configuration from '../modules/configuration';

const generatePathWithLocale = (newLocale) => {
  const config = Configuration.get();
  const baseLanguageCodes = config.getBaseLanguageCodes();
  const pathParts = window.location.pathname.split('/');

  if (baseLanguageCodes.includes(pathParts[1])) {
    pathParts[1] = newLocale;
  } else {
    pathParts.splice(1, 0, newLocale);
  }

  return pathParts.join('/');
};

export default generatePathWithLocale;
